import { Component, Input, OnInit } from '@angular/core';

import * as moment from 'moment';

import { MomentRoutingModule } from './moment.routing.module';

declare const $: any;

@Component({
  selector: 'moment',
  template: `<span *ngIf="date"><i class="fa fa-clock-o"></i> {{date | amTimeAgo}}</span>`,
})

export class MomentComponent {
  @Input() public name: string = '';
  @Input() public caption: string = '';
  @Input() public enabled: Boolean = false;
  @Input() public date: any;

  constructor() {
    //moment.locale('fr');
   }

  ngOnInit() {
    /*if (this.date) {
      let date = $.parseJSON('{"date":' + this.date + '}');
      this.date = new Date(date.date);
    }*/
  }

  setDate(date: any) {
    this.date = date;
  }
}
